import { useContext, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AbilityContext } from '../../shared/abilities/AbilityContext';
import MenuBar, { IMenuIconItem, IMenuItem } from '../../shared/components/menubar/MenuBar';
import { useConfirmationModalContext } from '../../shared/components/ModalConfirmationContext';
import useSlider from '../../shared/components/Slider/useSlider';
import { RootState } from '../../shared/store';
import * as constant from '../../shared/util/constant';
import { CustomerScreenTabs, SliderActivityConstant } from '../../shared/util/constant';
import './CustomerSliderContainer.scss';
import CustomerSliderContainerService from './CustomerSliderContainerService';
import { cleareTabsInputs, SliderDataAction, updateSliderCurrentTab, updateSliderData } from './CustomerSliderContext';
import SliderActivity, { SliderActivityHandles } from './slider-activity/SliderActivity';
import SliderContact from './slider-contact/SliderContact';
import SliderMailMerge from './slider-mailmerge/SliderMailMerge';
import SliderNote, { SliderNoteHandles } from './slider-note/SliderNote';
import SlidterTask from './slider-task/SliderTask';
import * as label  from '../../shared/util/label';
import SliderActivityHistory from './slider-activity-history/SliderActivityHistory';
import SliderEmailDocument from './slider-emaildocument/SliderEmailDocument';


export interface ICustomerSliderContainer {
    customerId? : string;
    navigateTo : (path : string) => void
}

const CustomerSliderContainer : React.FunctionComponent<any> = (props) => {
    const customerSliderContainerService = new CustomerSliderContainerService();
    const sliderContext = useSlider();
    const modalContext = useConfirmationModalContext();
    
    
    const dispatch = useDispatch();
    let customerSliderState = useSelector((state: RootState) => state?.CustomerSliderState);
    const originalCustomerObj = useSelector((state: RootState) => state?.customerSlice).customer;
    let customerPolicies = useSelector((state: RootState) => state?.customerSlice).policies;
    //const isMailMergeEnabled  = customerPolicies && customerPolicies.length > 0;

    const [currentTab, setCurrentTab] = useState(customerSliderState.currentTab);

    const ability = useContext(AbilityContext);
    const canUserViewCustomerContact = ability.can('view',"Customer",constant.ScreenName.CUSTOMER);
    const canUserReadCustomerContact = ability.can('read',"Customer",constant.ScreenName.CUSTOMER); 
    const canUserCreateCustomerTask = ability.can('create',"Customer Task",constant.ScreenName.CUSTOMER_TASK);
    const canUserCreateCustomerActivity = ability.can('create','Customer Activity',constant.ScreenName.CUSTOMER_ACTIVITY);
    const isNoteEnabled = ability.can('create', 'Customer Memo' ,constant.CustomerScreenName.CUSTOMER_NOTES);
    //const isMailMergeEnabled = ability.can('create', 'Customer Notes', constant.CustomerScreenName.CUSTOMER_NOTES);
   
    const sliderActivityRef = useRef<SliderActivityHandles>(null);
    const sliderNoteRef = useRef<SliderNoteHandles>(null);
    const sliderContactRef = useRef<SliderNoteHandles>(null);

    const activityData = customerSliderState.activityPage.activity;

    const menuItems : IMenuItem[] = [];

    let primaryActionIconMenuItems : IMenuIconItem[] = [
        {
            menuKey : CustomerScreenTabs.activity.key,
            iconName : 'activity',
            toolTip : "Activity",
            iconClass : "sld-menu-icons",
            isDisabled: !canUserCreateCustomerActivity
        },
        {
            menuKey : CustomerScreenTabs.contacts.key,
            iconName : 'contact',
            toolTip : "Contact",
            iconClass : "sld-menu-icons",
            isVisible: canUserViewCustomerContact,
            isDisabled: !canUserReadCustomerContact
        },
        {
            menuKey : CustomerScreenTabs.notes.key,
            iconName : 'note',
            toolTip : "Memo",
            iconClass : "sld-menu-icons",
            isDisabled : !isNoteEnabled
        },
        //{
        //    menuKey : CustomerScreenTabs.tasks.key,
        //    iconName : 'tasks',
        //    toolTip : "Task",
        //    iconClass : "sld-menu-icons",
        //    isDisabled: !canUserCreateCustomerTask
        //},
        {
            menuKey: CustomerScreenTabs.mailmerge.key,
            iconName: 'email',
            toolTip: "Mail Merge",
            iconClass: "sld-menu-icons",
            //isDisabled: !isMailMergeEnabled
        },
        {
            menuKey: CustomerScreenTabs.activityHistory.key,
            iconName: 'history',
            toolTip: "Activity History",
            iconClass: "sld-menu-icons",
            //isDisabled: !isMailMergeEnabled
        },
        {
            menuKey: CustomerScreenTabs.emaildoc.key,
            iconName: 'emaildoc',
            toolTip: "Email Document",
            iconClass: "sld-menu-icons",
            //isDisabled: !isMailMergeEnabled
        }
    ];
    
    let secondaryActionIconMenuItems : IMenuIconItem[] = [
        {
            menuKey : 'close',
            iconName : 'close',
            toolTip : "Close",
            iconClass : "sld-menu-icons"
        }
    ];

    if (sliderContext.isSliderPinned) {
        secondaryActionIconMenuItems = [
            {
                menuKey : 'pin',
                iconName : 'pin',
                iconClass : 'sld-menu-icons pin-icon-pinned',
                toolTip : "Unpin"
            }, ...secondaryActionIconMenuItems];
    }
    else {
       secondaryActionIconMenuItems = [
        {
            menuKey : 'pin',
            iconName : 'pin',
            toolTip : "Pin",
            iconClass : "sld-menu-icons"
        }, ...secondaryActionIconMenuItems];
    }
    
    const closeSlider = async () => {
        var moveToNextTab: any = true;

         let changes = customerSliderContainerService.getUnSavedChanges(customerSliderState, originalCustomerObj);

        if (Object.keys(changes).length > 0) {
            const result = await modalContext.showConfirmation(SliderActivityConstant.ARE_YOU_SURE_TO_EXIT, undefined, undefined, undefined, true);
             if(result) {
                //User chose to save the changes
                switch (currentTab) {
                    case CustomerScreenTabs.activity.key: 
                            moveToNextTab = await sliderActivityRef.current?.save();
                        break;
                    case CustomerScreenTabs.tasks.key:   
                        break;
                    case CustomerScreenTabs.notes.key:
                            moveToNextTab =  await sliderNoteRef.current?.save();
                        break;
                    case CustomerScreenTabs.contacts.key:   
                            moveToNextTab = await sliderContactRef.current?.save();
                        break;
                    default:
                        break;
                }
            }
            return moveToNextTab;
        }
        return true;

    };

    const onMenuClick = (menuKey) => {
        setCurrentTab(menuKey);
        dispatch(updateSliderCurrentTab(menuKey));
    };

    
    const onIconMenuItemClick = async (clickedMenuItemKey : IMenuIconItem) => {
        switch(clickedMenuItemKey.menuKey) {
            case "close": 
                   let close =  await closeSlider();
                    if(close){
                        dispatch(cleareTabsInputs());
                        sliderContext.hideSlider();
                        sliderContext.unpinSlider();
                        }
                break;
            case "pin": 
                if (sliderContext.isSliderPinned) {
                    sliderContext.unpinSlider();
                }
                else {
                    sliderContext.pinSlider();
                }
                break;
            case CustomerScreenTabs.activity.key:
            case CustomerScreenTabs.notes.key:
            case CustomerScreenTabs.contacts.key:
            case CustomerScreenTabs.tasks.key:
            case CustomerScreenTabs.mailmerge.key:
            case CustomerScreenTabs.activityHistory.key:
            case CustomerScreenTabs.emaildoc.key:
                activateTab(clickedMenuItemKey.menuKey);
                break;
            default:
                break;
        }
    };

    const activateTab = async (tabToShow : string ) => {
        var moveToNextTab: any = true;

        if (tabToShow == currentTab) {
            return;
        }
        
        let changes = customerSliderContainerService.getUnSavedChanges(customerSliderState, originalCustomerObj);
        if (Object.keys(changes).length > 0) {
            const result = await modalContext.showConfirmation(SliderActivityConstant.ARE_YOU_SURE_TO_EXIT, undefined, undefined, undefined, true);
            if(result) {
                //User chose to save the changes
                switch (currentTab) {
                    case CustomerScreenTabs.activity.key: 
                            moveToNextTab = await sliderActivityRef.current?.save();
                        break;
                    case CustomerScreenTabs.tasks.key:   
                        break;
                    case CustomerScreenTabs.notes.key:
                            moveToNextTab =  await sliderNoteRef.current?.save();
                        break;
                    case CustomerScreenTabs.contacts.key:   
                            moveToNextTab = await sliderContactRef.current?.save();
                        break;
                    default:
                        break;
                }
            }
        }
        if(moveToNextTab != false){
        dispatch(cleareTabsInputs());
        setCurrentTab(tabToShow);
        dispatch(updateSliderCurrentTab(tabToShow));
        if (tabToShow == CustomerScreenTabs.activity.key) {
            dispatch(updateSliderData({ type : SliderDataAction.ActivityUpdate, data : {...activityData, activityEffDate : new Date()}}));
        }
        }
    }

    const menuBarContent = <>
            <MenuBar 
                menuItems={menuItems} 
                onMenuClick={onMenuClick} 
                primaryActionIconMenuItems={primaryActionIconMenuItems}
                secondaryActionIconMenuItems={secondaryActionIconMenuItems} 
                onIconMenuClick={onIconMenuItemClick}
                selectedMenuKey={currentTab}
                navbarClass='slider-menu-header-nav-bar'>
            </MenuBar>
    </>;

    return <div className='customer-slider-main-div'>
        {menuBarContent}
        {currentTab == CustomerScreenTabs.activity.key && <SliderActivity ref={sliderActivityRef} customerId={props.customerId} navigateTo={props.navigateTo}></SliderActivity>}
        {currentTab == CustomerScreenTabs.notes.key && <SliderNote ref={sliderNoteRef} customerId={props.customerId} />}
        {currentTab == CustomerScreenTabs.contacts.key && <SliderContact ref={sliderContactRef} customerId={props.customerId}></SliderContact>}
        {currentTab == CustomerScreenTabs.tasks.key && <SlidterTask customerId={props.customerId} navigateTo={props.navigateTo}></SlidterTask>}
        {currentTab == CustomerScreenTabs.mailmerge.key && <SliderMailMerge customerId={props.customerId} navigateTo={props.navigateTo}></SliderMailMerge>}
        {currentTab == CustomerScreenTabs.activityHistory.key && <SliderActivityHistory customerId={props.customerId}></SliderActivityHistory>}
        {currentTab == CustomerScreenTabs.emaildoc.key && <SliderEmailDocument customerId={props.customerId} navigateTo={props.navigateTo}></SliderEmailDocument>}
    </div>;
};

export default CustomerSliderContainer